import { useRef } from 'react'
import { isMobile } from 'react-device-detect'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import 'swiper/css'
import 'swiper/css/free-mode'

export default function CategoryManyProduct() {
  const swiperRef = useRef<any>(null)

  return (
    <CategoryWrap
      className={isMobile ? 'category_wrap exhibition_category_header' : 'category_wrap exhibition_category_header pc'}
    >
      <div className='category'>
        <div className='inner'>
          <SwiperWrap
            ref={swiperRef}
            slidesPerView={'auto'}
            spaceBetween={12}
            breakpoints={{
              768: {
                spaceBetween: 20,
              },
            }}
            modules={[FreeMode]}
            freeMode={false}
            centeredSlidesBounds={true}
            slideToClickedSlide={true}
          >
            <SwiperSlideItem className={'on'}>
              <div className={'on'}>
                <Link
                  to={`#`}
                  onClick={(e) => {
                    e.preventDefault()
                  }}
                >
                  전체
                </Link>
              </div>
            </SwiperSlideItem>
          </SwiperWrap>
        </div>
      </div>
    </CategoryWrap>
  )
}

interface categoryWrapProps {
  twoDepCategoryNo?: number
  fourDepCategoryNo?: number
}

export const CategoryWrap = styled.div<categoryWrapProps>`
  /* 모바일: 3depth 카테고리 영역 */
  padding: 4px 0 0 0;
  border-bottom: ${({ twoDepCategoryNo, fourDepCategoryNo }) =>
    twoDepCategoryNo === fourDepCategoryNo ? '1px #e9e9e9 solid' : null};

  // 스크롤이 올렸을 때 (페이지가 내려갈 때) 카테고리 메뉴 fixed
  &.fixed {
    padding-bottom: 48px;
    & .swiper {
      position: fixed;
      /* top: 60px; */
      left: 0;
      width: 100%;
      background-color: var(--colWhite);
      z-index: 10;
      padding: 0 20px;

      // 첫번째 카테고리 after
      &:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        border-bottom: ${({ twoDepCategoryNo, fourDepCategoryNo }) =>
          twoDepCategoryNo === fourDepCategoryNo ? '1px #e9e9e9 solid' : null};
        z-index: -1;
      }
    }
  }

  & div.category {
    position: relative;
    width: 100%;
    padding: 0;
    top: 1px;
    & h2 {
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      padding: 12px 0 0 20px;
      position: relative;
      top: 0;
      transition: 0.2s;
    }
  }

  @media screen and (min-width: 768px) {
    /* 웹: 2Depth 카테고리 영역 */
    position: relative;
    width: 100%;
    padding: 0;

    // 스크롤 다운 될 때 fixed
    &.fixed {
      padding-bottom: 50px;
      & .inner {
        position: fixed;
        /* top: 84px; */
        left: 0;
        background-color: var(--colWhite);
        z-index: 3;
        width: 100%;
        border-bottom: 1px solid var(--colGray3);

        &:after {
          content: '';
          width: 100%;
          height: 1px;
          bottom: 0;
          left: 0;
          background-color: #e9e9e9;
          z-index: -1;
          position: absolute;
          display: none;
        }
        & .swiper {
          position: relative;
          top: 1px;
          left: auto;
          width: 1216px;
          margin: 0 auto;
          padding: 0;
          background: none;

          &:after {
            display: none;
          }
        }
      }
    }

    & div.category {
      position: relative;
      max-width: 1280px;
      margin: 0 auto;
      padding: 0 32px;
      z-index: 4;
      & h2 {
        color: var(--colBlack);
        font-size: 36px;
        font-weight: 600;
        line-height: 40px;
        padding: 32px 0 16px 0;
      }
    }
  }
`

// Tab Swiper 2Depth 영역
export const SwiperWrap = styled(Swiper)`
  overflow: hidden;
  z-index: 1;
  padding: 0 20px;

  & div.swiper-wrapper {
    & div.swiper-slide {
      width: auto !important;
      position: relative;
      & a {
        display: block;
        padding: 15px 2px;
        font-size: 16px;
        font-weight: 500;
        line-height: 18px;
        color: #a3a3a3;
        height: 50px;
      }
    }
    & div.on {
      & ::after {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2px;
        background: var(--colBlack);
        left: 0;
      }
      a {
        color: var(--colBlack);
        font-weight: 700;
      }
    }
  }

  @media screen and (min-width: 768px) {
    padding: 0;
    & div.swiper-wrapper {
      & div.swiper-slide {
        position: relative;
        & div {
          & p {
            font-size: 16px;
            font-weight: 500;
            line-height: 18px;
            color: #a3a3a3;
            cursor: pointer;
          }
        }
        & div.on {
          & p {
            font-weight: 700;
            color: var(--colBlack);
          }
          & a::after {
            content: '';
            display: block;
            position: absolute;
            bottom: 0px;
            width: 100%;
            height: 2px;
            background: var(--colBlack);
            left: 0;
          }
        }
      }
    }
  }
`

export const SwiperSlideItem = styled(SwiperSlide)``
